import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { LoadingFallback } from '@/components/LoadingFallback';

/**
 * Layout for authentication pages (login, etc.)
 * Redirects to inbox if already authenticated
 */
export function AuthLayout() {
  const { session, isLoading } = useAuth();

  if (isLoading) {
    return <LoadingFallback />;
  }

  // If already authenticated, redirect to inbox
  if (session) {
    return <Navigate to="/inbox" replace />;
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h1 className="text-center text-3xl font-bold text-gray-900">EasyHelp</h1>
        <h2 className="mt-2 text-center text-lg text-gray-600">Operator Console</h2>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
